import { Box, Typography, Link, CircularProgress } from '@mui/material'
import React, { useContext } from 'react'
import Logo from '../../assets/logo.png'
import Grid from '@mui/material/Grid';
//import resourceData from './resources/ResourceData'
import { useNavigate } from 'react-router-dom';
import { Condition, coonditionContext } from '../..';
import { LongPressGuard } from './LongPressGueard';
import { useDispatch } from 'react-redux';
import { showAuthProfile } from '../../features/dialogSlice';
//import { coonditionContext, Condition, capitalizeWords } from '''
export const privacyHref = 'https://www.polygonhealth.co/privacy-policy'//'https://www.polygonhealth.com/map/privacy-policy.htm'//https://www.polygonhealth.com/privacy-policy"
export const PrivacyLink: React.ReactElement = (
  <Link href={privacyHref} target="_blank" rel="noopener noreferrer">
    Privacy Policy
  </Link>
);
export const TermsOfUseHref = 'https://www.polygonhealth.co/termsofuse'//'https://www.polygonhealth.com/map/terms-of-use.htm' //"https://www.polygonhealth.com/termsofuse"
export const TermsOfUseLink: React.ReactElement = (
  <Link href={TermsOfUseHref} target="_blank" rel="noopener noreferrer">
    Terms of Use
  </Link>
);

export const HeaderContent: React.FC = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch<any>();
  const { condition } = React.useContext<Condition>(coonditionContext);


  return (
    <>
      <Box
        sx={{
          flexGrow: 50,
          display: 'flex',
          flexDirection: 'row',
          overflow: 'hidden',
        }}
      >
        <LongPressGuard onLongPress={() => dispatch(showAuthProfile(true))} onClick={() => navigate('/')} >
          <Box component="img" sx={{ height: 64, cursor: 'pointer', }}
            alt="Powered by Polygon Health"
            src={Logo}
          />
        </LongPressGuard>
        <Grid sx={{ cursor: 'pointer' }}>
          <Grid key={0} sx={{
            width: '100%', // xs=12 → full width
          }}>
            <Typography
              variant="h6"
              noWrap
              component="pre"
              onClick={() => navigate('/')}
              sx={{
                letterSpacing: '0rem',
                color: 'black',
                textDecoration: 'none',
                fontWeight: 'bold',
                fontSize: {
                  xs: '10px',
                  sm: '1.3rem'
                },
                pt: {
                  xs: 1.5,
                  sm: 0.5
                }
              }}
            >
              {condition} Patient Connect
            </Typography>
          </Grid>
          <Grid key={1} sx={{
            width: '100%', // xs=12 → full width
          }}>
            <Typography
              onClick={() => { window.open("https://www.polygonhealth.co", '_blank') }}
              variant="caption"
              noWrap
              component="pre"
              sx={{
                color: 'black',
                textDecoration: 'none',
              }}
            >
              Powered by Polygon Health
            </Typography>
          </Grid>
        </Grid>
      </Box>

    </>)
}

export const CircularProgressCentered = () => {
  return (
    <div style={{
      position: 'absolute',
      // padding: '0', display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', width: '100%', 
      top: '50%',
      left: '50%',
      //backgroundColor: 'grey'
    }}>
      <CircularProgress />
    </div>)
}